import Header from '@components/Header';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';

import LogItems from './components/LogItems';

interface Params {
    prepaidCardId: string;
}

const PrepaidCardLogActivity: ActivityComponentType<Params> = ({ params }:{params: Params}) => {
  const { prepaidCardId } = params;
  return (
        <AppScreen>
            <Header title='이용 내역' />
            <LogItems id={prepaidCardId}/>
        </AppScreen>
  );
};

export default PrepaidCardLogActivity;
